
export const AstricSign=()=>{
    return(
        <text style={{color:'red', fontSize:'12px'}}> *</text>
    )
}